import { ServiceSessionUserEvent } from '@modules/ServiceModule';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';
import { AcceptedOnDevice, TaskState } from '@modules/TasksModule/types';
import InboxModule from '..';
import {
  setCallToCompleted,
  setCallToWrapup,
} from '@modules/InboxModule/callHandlers/callStateHandler';

function handleSessionHangup(
  context: InboxContext,
  event: ServiceSessionUserEvent,
) {
  // Account-broadcast HANGUP is keyed by sessionSid. Another agent's
  // delayed terminate (same conversation, coalesced ~1s) must not wrap
  // our OtherDevice task. Same filter as offered / delivered / recovery.
  if (event.userId !== context.userId) {
    return;
  }

  const task = TasksModule.getTaskBySessionSid(event.sessionSid);

  if (!task) {
    return;
  }

  if (TasksModule.getTask(task.id)) {
    TasksModule.setTaskAttribute(task.id, 'callEndedTime', Date.now());
  }

  // we only want to transition tasks that are in accepted state
  if (task.state !== TaskState.Accepted) {
    return;
  }

  // pass task.id, not event.sessionSid: the task may still be keyed by
  // callId, and setCallToWrapup/setCallToCompleted look it up again by the
  // id we give them
  if (task?.attributes.acceptedOn === AcceptedOnDevice.OtherDevice) {
    if (
      InboxModule.shouldRetainEndedCallCard(task) ||
      task.attributes.shouldClassify
    ) {
      setCallToWrapup(context, task.id);
    } else if (!task.attributes.shouldClassify) {
      setCallToCompleted(context, task.id, false);
    }
  }
}

export default handleSessionHangup;
